export enum ConnectionType {
  PUSH = 'PUSH',
  PULL = 'PULL',
}

export enum ConnectorsFieldName {
  name = 'name',
  enabled = 'enabled',
  connectionType = 'connectionType',
}

export type ConnectorBase = {
  name: string;
  enabled: boolean;
  connectionType: ConnectionType;
};
